import { Analytics } from "utils/analytics"
import { Tooltip } from "components/Tooltip"
import { SocialNetwork } from "components/Footer/components/SocialNetworksLinks"

interface Props {
    network: SocialNetwork
}

export function DescriptionOverlay({ network }: Props) {
    const content = (
        <a
            key={network.name}
            onClick={() =>
                Analytics.user_followed_the_link_to_social_network({
                    socialNetwork: network.name,
                })
            }
            target="_blank"
            rel="noopener noreferrer"
            href={network.link}
            className={network.className}
        >
            <span className="footer__social-network">{network.name}</span>
            {network.overlay && "*"}
        </a>
    )
    return network.overlay ? (
        <Tooltip placement={"top"} overlay={network.overlay}>
            {content}
        </Tooltip>
    ) : (
        content
    )
}
